import { EFilterType } from './../../enums/EFilterType';
import { IBaseProps, IDataType } from "../../types/data";
import { IOYFilterBarProps } from '../OYFilterBar/const';
import { OYIndustryComponetData } from '../OYIndustryComponet/const';

type BarType = Pick<IOYFilterBarProps,
  'tags'
  | 'activedSaveName'
  | 'showFastQueryList'
  | 'fastQueryList'
  | 'operations'
  | 'renderRight'
  | 'onFeedbackClick'
  | 'onSave'
  | 'onSaveListClick'
  | 'onSaveListDelete'
>

export interface IOYFilterProps extends IBaseProps, BarType {
  /**
   * 表格宽度
   */
  width?: number | string;
  /**
   * 标题宽度
   */
  titleWidth?: number;
  /**
   * 列表显示数量。超出的点击展开更多显示
   * 如果传入true则表示全部显示
   * @default 8
   */
  showItems?: number | boolean;
  /**
   * 选中的值
   */
  value: { [i: string]: any };
  /**
   * 数据
   */
  data: { [i: string]: IDataType };
  /**
   * 是否在加载中
   */
  loading: boolean;
  /**
   * 是否更新url信息
   */
  location?: boolean;

  /** industryComponet start */
  /**
   * 图片基础路径
   */
  industryComponetStaticPath?: string;
  /**
   * 爆炸图数据
   */
  industryComponetValue?: string;
  /**
   * 爆炸图数据
   */
  industryComponet?: OYIndustryComponetData[];
  /** industryComponet stop */
  /**
   * 点击移除标签
   * @param data
   * @param index
   */
  onTagRemove?: IOYFilterBarProps["onRemove"];
  /**
   * 点击重置标签
   */
  onTagReset?: IOYFilterBarProps['onReset'];
  /**
   * 点击保存按钮
   */
  onSaveIconClick: IOYFilterBarProps['onSaveIconClick'];
  /**
   * 在change之前回调函数。
   * 如果返回true。正常执行onChange
   * 如果返回false。则不触发onChange
   * @param value
   * @param keys
   * @description 针对特殊逻辑做处理
   */
  beforeChange?(value: string, keys: string[]): boolean;
  /**
   * 触发change事件
   * @param {string} value
   * @param {string[]} keys
   */
  onChange?(value: string, keys: string[]): void;
  /**
   * 触发搜索事件
   * @param params
   */
  onSearch?(params: any): void;
  /**
   * 爆炸图点击事件
   * @param name 名称
   * @param value 值
   */
  onIndustryComponetClick?(name: string, value: string): void;
  /**
   * 点击切换展开收起
   */
  onToogle?(): void;
  /**
   * 错误重载回调
   * 需要配合实例方法filter.showError方法使用
   * @description 在调用filter.showError()方法后。在显示的错误页面中点击重新加载才能触发该事件
   */
  onErrorReload?(): void;
  /**
   *  筛选器频道触发点击事件
   *
   * @param {{ value: string, name: string }} data 数据
   * @param {number} index 当前数据索引
   */
  onChannelClick?(data: { value: string, name: string }, index: number): void;
}

export interface IOYFilterState {
  keywordAnalyseResult: string;
  keywordAnalyseResultTags: any[]
  params: IParams,
  keyTypeMap: { [i: string]: EFilterType },
  showItems: number;
  /**
   * 是否展开收起
   */
  expand: boolean;
  showError: boolean;
  errorText: string;
  errorImg: string;
  serviceTooltips: {
    [i:string]: string
  };
}

export interface IParams { [i: string]: string[] | IParams; }
export interface IPropsPrams { [i: string]: string | string[] | IPropsPrams | { name: string; value: string }[]; }

export const inputTypes = [
  EFilterType.Input, //输入框  4
  EFilterType.InputRange, //范围输入框  5
  EFilterType.DropdownInput,  //下拉框式输入框  14
  EFilterType.DropdownInputRange,//下拉框式范围输入框  15
  EFilterType.DatePicker //时间选择 16
]

function renderRangeInputFilterTag([start = '', stop = '']: string[], unit = '') {
  if (start && !stop) {
    return `大于${start}${unit}`
  } else if (!start && stop) {
    return `小于${stop}${unit}`
  }
  return `${start}-${stop}${unit}`
}

export const filterData = {
  shopSign: {
    flatSearch: true,
    maxTextLength: 12,
    width: 130,
    renderFilterTagTitle: (title = '') => title === '同类推荐' ? '牌号' : title
  },
  spec1: {
    flatSearch: true,
  },
  spec: {
    info: {
      heightSpec: {
        renderFilterTag: (val: string[]) => renderRangeInputFilterTag(val, 'mm')
      },
      lenghtSpec: {
        renderFilterTag: (val: string[], result: any) => {
          return result ? result.name : renderRangeInputFilterTag(val, 'mm')
        }
      },
      widthSpec: {
        renderFilterTag: (val: string[]) => renderRangeInputFilterTag(val, 'mm')
      }
    }
  },
  balanceWeight: {
    renderFilterTag(value: string) {
      const [start = '', stop = ''] = value.split('/');
      return renderRangeInputFilterTag([start, stop], '吨')
    }
  },
  manufacture: {
    // 材料店铺卡片高度为48px
    cardHeight: /\/gyl-ng\/futures\/==AO0IDOwEDV\/index/.test(window.location.pathname) ? 48 : 66,
    renderCardItem(item: any) {
      const { url, weight } = item;
      const baseUrl = '//cdn-ng.ouyeel.com/statics';
      const weightTpl = weight !== undefined ? `<div title="共${weight}吨" style="color:#999999;font-size:12px;margin:4px 0;" class="ellipsis">共${weight}吨</div>` : '';
      return `
      <div>
        <div style="width:132px;height:42px;">
          <img src="${baseUrl}${url}" style="max-width:100%;max-height:100%;">
        </div>
        ${weightTpl}
      </div>
      `
    }
  },
  storeCity: {
    width: 130,
    cateBtnText: '按区域分类',
    subKey: 'weight',
    flatSort(aa: any, bb: any) {
      return (bb.weight || 0) - (aa.weight || 0)
    },
    renderSub(value: string) {
      return `共${value}吨`
    }
    // renderFilterTag(value: string, item: any) {
    //   return item ? item.name : value;
    // }
  },
  qualityGrade: {
    group: true
    // info: {
    //   qualityGoods: {
    //     // cells: 4
    //     // width: 195
    //   },
    //   qualityNotGoods: {
    //     // cells: 4
    //     // width: 195
    //   }
    // }
  },
  warehouse: {
    cells: 4
  },
  productProp: {
    namehidden: true,
    colspan: true
  },
  channel: {
    enable: false
  },
  service: {
    collapse: true
  },
  deliveryCycle2: {
    collapse: true,
    subKey: 'balanceWeight',
    renderSub(value: string) {
      return `剩余可供${parseInt(value, 10)}吨`
    }
  },
  other: {
    info: {
      publishPrice: {
        renderFilterTag: (val: string[]) => renderRangeInputFilterTag(val, '元')
      }
    }
  }
}

// 增加映射，这边每次增加筛选条件这边不增加映射的话刷新页面，url上的筛选条件会刷新掉
// 筛选条件映射关系
const filterParamMap = {
  "productType": [],
  "shopSign": [],
  "spec": {
    "heightSpec": [],
    "widthSpec": [],
    "lengthDef": [],
    "lenghtSpec": [],
    "accurateFlag": []
  },
  "balanceWeight": [],
  "provider": [],
  "manufacture": [],
  "storeCity": [],
  "qualityGrade": {
    "qualityGoods": [],
    "qualityNotGoods": []
  },
  "flag": {
    "stockFlag": [],
    "qualityFlag": []
  },
  "warehouse": [],
  "service": {
    "bulkDiscount": [],
    "flagDingjin": [],
    "flagZhibaoshu": [],
    "hasEPD": [],
    "hasFreight": [],
    "hasFreightSubsidy": [],
    "isAfterSaleService": [],
    "isAfterSettleAlias": [],
    "isBailAllowed": [],
    "isIntentionPayment": [],
    "isQuicklyWarehousing": [],
    "quickInvoicingFlag": [],
    "supportGoodsPhotos": [],

    "hasSellerMedal": [],
    "loanOrBailAllowed": [],
    "canCompensateFlag": [],
    "isResell": [],
    "promiseTime": [],
    "isBargain": [],
    "videoInspectionFlag": []
  },
  "resourceSeries": {
    "resourceZone": [],
    "resourceZone2": [],
    "entryMode": [],
    "newResource": [],
    "salesMethod": [],
    "resourceType": [],
    "isCompetitiveRes": [],
    "isTargeting": [],
    "consignment": [],
    "canBuy": [],
    "lkq": [],
    "qita": []
  },
  "deliveryCycle2": [],
  "productProp": {
    "paintType": [],
    "coatingStructure": [],
    "color": [],
    "claddingZnLayer": [],
    "coatingType": [],
    "tensionKl": [],
    "surfaceTreatment": [],
    "tensionQf": [],
    "tensionSc": [],
    "techStandard": [],
    'qualityGrade': []
  },
  "other": {
    "hasVideo": [],
    "hasRealPicture": [],
    "publishPrice": [],
    "curSection": [],
    "shopSignLike": []
  },
  "channel": [],
  "steelProvider": []
}

export function getStringVavlueFilterParamMap(data = filterParamMap) {
  const obj = JSON.parse(JSON.stringify(data));
  $.each(obj, (key, value) => {
    if ($.isArray(value)) {
      obj[key] = ''
    } else if ($.isPlainObject(value)) {
      obj[key] = getStringVavlueFilterParamMap(value)
    }
  })
  return obj;
}

/**
 * 获取平铺结构的filterParamMap 键值对
 * @param data
 */
export function getFlatStringValueFilterParams(data = getStringVavlueFilterParamMap()) {
  let obj: any = {};
  $.each(data, (key, value) => {
    if ($.isPlainObject(value)) {
      obj = { ...obj, ...getFlatStringValueFilterParams(value) }
    } else if (typeof value === 'string') {
      obj[key] = ''
    }
  })

  return obj;
}

export function getFilterParamMap() {
  return JSON.parse(JSON.stringify(filterParamMap))
}

// /**
//  * 获取筛选条件key
//  * @param data
//  */
// export function getFlatFilterParamMap(data = filterParamMap) {
//   let obj: any = {};
//   $.each(data, (key, value) => {
//     if (value instanceof Array) {
//       obj[key] = ''
//     } else if ($.isPlainObject(value)) {
//       obj = { ...obj, ...getFlatFilterParamMap(value) }
//     }
//   })

//   return obj
// }

/**
 * 判断两个对象key value是否一致。
 * @param obj
 * @param obj2
 * @description 这个只做了一层比对！！！
 */
export function isSameObject(obj: any, obj2: any) {
  const aProps = Object.getOwnPropertyNames(obj);
  const bProps = Object.getOwnPropertyNames(obj2);

  if (aProps.length !== bProps.length) {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let idx = 0; idx < aProps.length; idx++) {
    const propName = aProps[idx];
    const propA = obj[propName];
    const propB = obj2[propName];
    if (propA !== propB) {
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/const.ts